import { render } from "./NormalButton.vue?vue&type=template&id=799cb3cc&scoped=true&bindings={\"bgColor\":\"props\",\"color\":\"props\",\"fullWidth\":\"props\",\"style\":\"options\",\"colorStyle\":\"options\",\"width\":\"options\"}"
import script from "./NormalButton.vue?vue&type=script&lang=js"
export * from "./NormalButton.vue?vue&type=script&lang=js"

import "./NormalButton.vue?vue&type=style&index=0&id=799cb3cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-799cb3cc"

export default script